module.exports = __webpack_public_path__ + "files/afc758684737899ed0618c050aecd7da.png";